import { takeEvery, takeLatest, select, put, take } from 'redux-saga/effects'
import {
  UPDATE_ECP,
  updateEcpModule,
  ECP_MODULES_STATE_RECEIVED,
  SOLENOIDS_RECEIVED,
  getSolenoids,
  fetchEcpLinkedFeatures,
} from 'actions/ecp'
import { GET_TRUCK_DETAILS } from 'actions/truck'
import {
  ecpForUpdate,
  getECPVariantForVehicle,
  getOccupiedSlotSolenoids,
} from 'selectors/ecp'
import { getECPModuleList } from 'selectors/truck'

export function* watchUpdateEcp() {
  yield takeEvery(UPDATE_ECP, updateEcp)
}

function* updateEcp({ id, serialNumber, note, callback }) {
  const ecp = yield select((state) => ecpForUpdate(state, { id }))
  yield put(updateEcpModule(serialNumber, id, note, ecp, callback))
}

export function* watchFetchEcps() {
  yield takeEvery(GET_TRUCK_DETAILS, setEcpState)
}

function* setEcpState(action) {
  const { serialNumber } = action
  const ecps = yield select((state) =>
    getECPModuleList(state, { serialNumber })
  )
  yield put({
    type: ECP_MODULES_STATE_RECEIVED,
    serialNumber,
    ecps,
  })
}

export const isSolenoidsReceivedFor = (ecpVariant) => (action) =>
  action.type === SOLENOIDS_RECEIVED && action.ecpVariant === ecpVariant

export function* watchEcpState() {
  yield takeLatest(ECP_MODULES_STATE_RECEIVED, getSolenoidsData)
}

export function* getSolenoidsData({ serialNumber }) {
  const ecpVariant = yield select(getECPVariantForVehicle)
  if (!ecpVariant) return
  yield put(getSolenoids(ecpVariant))
  yield take(isSolenoidsReceivedFor(ecpVariant))
  yield* fetchOptionalSolenoidDescriptions(serialNumber)
}

export function* fetchOptionalSolenoidDescriptions(serialNumber) {
  if (!serialNumber) return
  const solenoids = yield select(getOccupiedSlotSolenoids)
  const seen = new Set()
  const unique = Object.values(solenoids || {}).filter((s) => {
    if (!s.outputId || !s.ecuModule) return false
    const key = `${s.ecuModule}-${s.outputId}`
    if (seen.has(key)) return false
    seen.add(key)
    return true
  })
  for (const solenoid of unique) {
    yield put(
      fetchEcpLinkedFeatures({
        outputId: solenoid.outputId,
        moduleType: solenoid.ecuModule,
        serialNumber,
      })
    )
  }
}
